import styled, { css } from 'styled-components';

import type { BadgeSize } from '../Badge';

export const BadgeNumerical = styled.p<{ size: BadgeSize }>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-on-critical);
  background-color: var(--action-critical-default);
  border-radius: 20px;

  ${props =>
    props.size === 'small' &&
    css`
      height: 16px;
      min-width: 16px;
      padding: 0 5px;
    `};

  ${props =>
    props.size === 'medium' &&
    css`
      height: 20px;
      min-width: 20px;
      padding: 2px 7px;
    `};
`;
